import type { TOC } from '@ember/component/template-only'
import type DeleteClassesRoute from 'teacher-ui-client/manage/rollover/steps/delete-classes/route'
import type DeleteClassesController from 'teacher-ui-client/manage/rollover/steps/delete-classes/controller'
import { t } from 'ember-intl'
import { RolloverClassSelectionTable } from 'teacher-ui-client/components/rollover/class-selection-table'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { or, not } from 'ember-truth-helpers'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { RolloverDeleteClassesPrompt } from 'teacher-ui-client/components/rollover/delete-classes-prompt'
import RouteTemplate from 'ember-route-template'
import { InlineAlert, AlertType, InlineAlertSubtitle } from 'teacher-ui-client/components/inline-alert'

interface Signature {
  Args: {
    model: ModelFor<DeleteClassesRoute>
    controller: DeleteClassesController
  }
}
export const ManageRolloverStepsDeleteClassesPage: TOC<Signature> = <template>
  <div class="mx-auto max-w-3xl px-2">
    <div class="mb-12">
      <h3 class="text-dusty-black-250 mt-8 mb-6">
        {{t "manage.rollover.steps.delete_classes.stepContentHeader"}}
      </h3>
      <div class="space-y-6">
        <p class="text-xl">
          {{t "manage.rollover.steps.delete_classes.reviewClasses"}}
        </p>
        <p class="text-xl">
          {{t "manage.rollover.steps.delete_classes.classesCreatedDuringRollover" htmlSafe=true}}
        </p>
        <InlineAlert @type={{AlertType.Warning}} role="alert">
          <InlineAlertSubtitle>
            <p class="mb-3">{{t "manage.rollover.steps.delete_classes.recommendDeleting" htmlSafe=true}}</p>
            <span>{{t "manage.rollover.steps.delete_classes.deletingClassesNote" htmlSafe=true}}</span>
          </InlineAlertSubtitle>
        </InlineAlert>
      </div>
    </div>
  </div>
  <div class="mx-auto max-w-6xl px-2">
    <div class="mb-6">
      <RolloverClassSelectionTable
        @schoolClasses={{@controller.schoolClassesForTable}}
        @selectedItemIds={{@controller.selectedItemIds}}
        @onSortClick={{@controller.updateSorts}}
        @onSelectClick={{@controller.updateSelected}}
        @sortingConfig={{@controller.sortingConfig}}
        @paginationConfig={{@controller.paginationConfig}}
        @isLoadingData={{@controller.fetchPreRolloverClasses.isRunning}}
      />
    </div>
  </div>
  <div class="mx-auto max-w-3xl px-2">
    <div class="text-right">
      <UiButton
        data-test-delete-classes-button
        disabled={{or @controller.fetchPreRolloverClasses.isRunning (not @controller.selectedItemIds)}}
        @appearance={{ButtonAppearance.regular}}
        {{on "click" (fn @controller.setSchoolClassesToDelete @controller.selectedClasses)}}
      >
        {{t "manage.rollover.steps.delete_classes.deleteClassesButton"}}
      </UiButton>
    </div>
  </div>

  <RolloverDeleteClassesPrompt
    @classesToDelete={{@controller.schoolClassesToDelete}}
    @afterAction={{@controller.afterPromptAction}}
  />
</template>

export default RouteTemplate(ManageRolloverStepsDeleteClassesPage)
